import gql from 'graphql-tag';

// Comments plan 3b: the people one may @mention: members of the account and of its teams (the server keeps only those
// who may open the page). Hasura shows a non-sysadmin only people who share a group or team with them.
export default gql`
query getCommentMembers($groupId: Int!) {
  users(
    where: {_and: [
      {deactivated: {_neq: true}},
      {_or: [
        {users_roles_groups: {group_id: {_eq: $groupId}}},
        {users_roles_teams: {team: {teams_items: {_or: [
          {folder: {group_id: {_eq: $groupId}}},
          {project: {group_id: {_eq: $groupId}}},
          {page: {group_id: {_eq: $groupId}}}
        ]}}}}
      ]}
    ]},
    order_by: {full_name: asc}
  ) {
    user_id
    full_name
  }
}
`;
